import { getServices } from '~/db/services';

export const useCategoryGetParamsAssessmentForm = (
  pageContextType: CategoryPageContextTypes
): UseCategoryGetParams => {
  const { $db } = useNuxtApp();

  const { categoriesService } = getServices($db);

  const section = ref<Sections>(Sections.ChildForYou);

  const { currentContent, currentDiscipline } = inject(INJECT_ASSESSMENT_FORM);

  const slug = ref<string>();

  const load = async () => {
    if (currentDiscipline.value && currentDiscipline.value.slug) {
      slug.value = currentDiscipline.value.slug;
    } else {
      // We are on the root page (no slug category), asking for course&quiz content of the lb
      const root = await categoriesService.getByContentTypesAndLb(
        ['course&quiz'],
        currentContent.value.id
      );
      slug.value = root.slug;
    }
  };

  return {
    pageContextType,
    currentContent,
    section,
    slug,
    isStudyContent: true,
    baseCategory: null,
    isHome: false,
    load,
  };
};
